module.exports = __webpack_public_path__ + "static/img/chuhuo.7223322.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chuhuo.png
// module id = 1rI+
// module chunks = 128